<div class="text-box-wrapper" >

  <label class="field-label">{{ filterBase.label }}</label>

  <div class="input-wrapper">

    <!-- search icon for search type -->
    @if (isSearch) {
      <mat-icon class="prefix-icon">search</mat-icon>
    }

    <!-- number icon for number type -->
    @if (isNumber) {
      <mat-icon class="prefix-icon">tag</mat-icon>
    }

    <input
      [(ngModel)]="value"
      (ngModelChange)="onValueChange()"
      [type]="inputType"
      [placeholder]="filterBase.label"
      [min]="isNumber ? 0 : null"
      class="text-input"
      [class.has-icon]="isSearch || isNumber"
      autocomplete="off"/>

      <!-- clear button -->
      @if (value) {
        <button
          class="clear-btn"
          mat-icon-button
          (click)="clearField()"
          aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      }

    </div>
  </div>